<template>
  <div class="edt">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">{{ pageTitle }}
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <v-btn
          color="primary"
          class="mr-4"
          medium
          @click="onCancel"
          :disabled="form.$busy"
          text
          style="text-transform: none;"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save</v-btn>
      </div>
    </v-app-bar>
    <v-row class="px-4 py-4">
      <v-col
        lg="8"
        md="6"
        sm="12"
        xs="12"
      >
        <v-card
          outlined
          class="px-6 py-8"
        >
          <v-text-field
            v-model="promoURL"
            outlined
            readonly
            label="Promo URL"
            append-outer-icon="mdi-content-duplicate"
            @click:append-outer="copyLink"
          />

          <v-text-field
            v-model="form.go_url_title"
            outlined
            label="Promo Name"
            :error-messages="form.$getError('go_url_title')"
          />

          <v-autocomplete
            :items="sportsbooks_option"
            clearable
            outlined
            label="Bookie"
            v-model="form.bookmaker_id"
          ></v-autocomplete>

          <v-textarea
            v-model="form.affiliate_hyperlink"
            outlined
            label="Promo Affiliate URL"
            :error-messages="form.$getError('affiliate_hyperlink')"
          >
          </v-textarea>

        </v-card>
      </v-col>
      <v-col
        lg="4"
        md="6"
        sm="12"
      >
        <slug-generator
          ref="slugGenerator"
          :base-string="form.go_url_title"
          component-label="Promo 'go' URL slug"
          v-model="slug"
          :error-messages="form.$getError('go_url_slug')"
        />
        <!-- <v-card
          outlined
          class="px-6 pt-6 mt-6"
        >
          <div class="d-flex flex-row justify-space-between align-center pb-3 ">
            <label class="subtitle-1 d-block grey--text">URL Properties</label>
          </div>

          <color-picker
            label="URL Color"
            v-bind:color.sync="form.url_color"
            :error-messages="form.$getError('url_color')"
          />

          <label class="subtitle-1 grey--text pt-1 mt-4">Bold</label>
          <v-switch
            color="success"
            v-model="form.is_url_bold"
          />

          <label class="subtitle-1 grey--text pt-1 mt-4">Underlined</label>
          <v-switch
            color="success"
            v-model="form.is_url_underlined"
          />
        </v-card> -->
      </v-col>
    </v-row>
    <v-overlay
      absolute
      :value="loading"
    >
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Form from '@/utils/form'
import get from 'lodash/get'
import head from 'lodash/head'
import replace from 'lodash/replace'
import InArticlePromo from '@/models/InArticlePromo'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import { mapActions, mapState } from 'vuex'
import slugify from 'slugify'
import SlugGenerator from '@/components/SlugGenerator'
import ColorPicker from '@/components/ColorPicker'

const initialData = {
  go_url_title: null,
  affiliate_hyperlink: null,
  go_url_slug: null,
  url_color: '#DF4661',
  is_url_bold: false,
  is_url_underlined: true,
  bookmaker_id: null

}

export default {

  components: {
    AppBarNavIcon,
    SlugGenerator,
    ColorPicker
  },

  data () {
    return {
      loading: false,
      updating: false,
      loading_message: 'Loading Bookie List',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      loadingTags: false,
      form: new Form({
        ...initialData
      }),
      sportsbooks_option: []
    }
  },
  props: {
    inArticlePromo: {
      type: [InArticlePromo, Object],
      default () {
        return {}
      }
    },
    pageTitle: {
      type: String,
      default: 'In-Article Promo'
    },
    redirectCancelTo: {
      type: [String, Object],
      default () {
        return {
          name: 'in-article-promos'
        }
      }
    },
    redirectSaveTo: {
      type: [String, Object],
      default () {
        return {
          name: 'in-article-promos'
        }
      }
    }
  },

  methods: {
    head,
    replace,
    ...mapActions({
      updateRecord: 'inArticlePromo/update',
      getBookList: 'bookmaker/getBookList'
    }),

    onCancel () {
      this.$router.replace(this.redirectCancelTo)
    },

    async onSave () {
      try {
        this.form.$busy = true
        this.form.$clearErrors()
        const data = this.form.$data()

        data.go_url_slug = this.slug

        if (this.isModeUpdate) {
          data._method = 'put'
        }

        const inArticlePromo = new InArticlePromo(data)
        await inArticlePromo.save()

        this.$router.replace(this.redirectSaveTo)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    copyLink () {
      var vm = this
      this.$copyText(process.env.VUE_APP_WEB_URL + '/go/' + this.slug).then(function () {
        vm.showSnackbar('Promo link copied.', 'success')
      }, function () {
        vm.showSnackbar('Failed to copy.', 'error')
      })
    },
    async fetchSportsBookList (page = 1) {
      let params = { page }

      params.sort = '-created_at'
      params.per_page = 'all'
      this.loading = true
      await this.getBookList(params)

      let sportsBooks = this.sportsBooksList

      sportsBooks.forEach((value, key, map) => {
        let bookStates = ''
        value.states.forEach((state, key, map) => {
          if (value.states.length > 0) {
            bookStates += state.name
            if (value.states.length !== key + 1) {
              bookStates += ', '
            }
          }
        })

        let optionText = value.states.length > 0 ? value.name + ' (' + bookStates + ')' : value.name
        this.sportsbooks_option.push({
          text: optionText,
          value: value.id
        })
      })
      this.loading = false
    }

  },

  watch: {
    inArticlePromo: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            ...initialData,
            ...val
          })

          if (val.hyperlinked_url) {
            this.form.bookmaker_id = val.hyperlinked_url.id
          }

          if (!this.form.go_url_slug) {
            this.$nextTick(() => this.$refs['slugGenerator'].generate())
          }
        }
      }
    }
  },

  computed: {
    ...mapState({
      sportsBooksList: state => state.bookmaker.list
    }),
    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    },
    slug: {
      get () {
        // if (this.form.go_url_slug && this.form.go_url_slug.trim() !== '') {
        //   return this.form.go_url_slug
        // }

        if (this.form.go_url_title) {
          return slugify(this.form.go_url_title, {
            remove: /[*+~.()'"!:@]/g,
            lower: true,
            strict: true
          })
        }

        return ''
      },
      set (v) {
        this.form.go_url_slug = v
      }
    },
    promoURL () {
      return process.env.VUE_APP_WEB_URL + '/go/' + this.slug
    }
  },

  created () {
    this.fetchSportsBookList()
  }
}
</script>
